module.exports = __webpack_public_path__ + "assets/img/21_1518_big.ae5a8c38.jpg";